var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M14.223 24.584c-.639.805-1.934.364-1.95-.663L12.05 8.9h10.1c1.829 0 2.85 2.112 1.712 3.545l-9.638 12.138Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillOpacity: 0.2,
    d: "M14.223 24.584c-.639.805-1.934.364-1.95-.663L12.05 8.9h10.1c1.829 0 2.85 2.112 1.712 3.545l-9.638 12.138Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ECF8E",
    d: "M10.116.415c.639-.804 1.934-.363 1.949.664l.099 15.02H2.19c-1.83 0-2.85-2.113-1.712-3.545L10.116.415Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 12.049,
    x2: 21.025,
    y1: 12.231,
    y2: 15.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#249361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ECF8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 8.069,
    x2: 12.163,
    y1: 6.782,
    y2: 14.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo05);
export default __webpack_public_path__ + "static/media/logo-05.24f36982d95a80c9af630ffba6509a83.svg";
export { ForwardRef as ReactComponent };